import { NAMESPACE } from 'locale'
import { useTranslation } from 'react-i18next'
import { Input, FormCard, FormItem } from '@lmc/ui-kit'
import { serviceUserProfileConstants as supConstants } from 'locale/serviceUserProfile'
import { Text } from '@lmc/ui-kit/src/general'

export const NameFormCard = () => {
  const { t } = useTranslation(NAMESPACE.SERVICE_USER_PROFILE)

  return (
    <FormCard title={t(supConstants.NAME)}>
      <FormItem
        label={<Text>{t(supConstants.PREFERRED_NAME)}</Text>}
        name="preferredName"
      >
        <Input maxLength={35} />
      </FormItem>
      <FormItem
        label={<Text>{t(supConstants.FIRST_NAME)}</Text>}
        name={['name', 'first']}
        rules={[
          {
            required: true,
            message: `${t(supConstants.PLEASE_ENTER)} ${t(
              supConstants.FIRST_NAME
            )}`,
          },
        ]}
      >
        <Input maxLength={35} />
      </FormItem>
      <FormItem
        label={<Text>{t(supConstants.LAST_NAME)}</Text>}
        name={['name', 'last']}
        rules={[
          {
            required: true,
            message: `${t(supConstants.PLEASE_ENTER)} ${t(
              supConstants.LAST_NAME
            )}`,
          },
        ]}
      >
        <Input maxLength={35} />
      </FormItem>
    </FormCard>
  )
}
